import React, { Component } from "react"
import Util from "../../Util"
import { TableLayout } from "../../components"
import { withRouter, Link } from "react-router-dom"
import * as ApiHelper from "../../ApiHelper"
import { ToastContainer, ToastMessage } from "react-toastr"
import { confirmAlert } from "react-confirm-alert"
class TableUsuarios extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.delete = this.delete.bind(this)
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  delete(id) {
    confirmAlert({
      title: "Confirme a remoção",
      message: "Tem certeza que deseja deletar?",
      buttons: [
        {
          label: "Sim",
          onClick: () =>
            ApiHelper.deleteUsuario(id, error => {
              if (error) {
                this.addAlert("", error.message)
              } else {
                this.props.onDelete()
              }
            })
        },
        {
          label: "Não"
        }
      ]
    })
  }

  render() {
    var buttons = [
      {
        title: "Criar usuário",
        link: "/usuarios/create",
        icon: "control_point"
      }
    ]
    var tableHeaders = ["CPF", "Nome", "Email", "Telefone", "Nível"]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />

        <TableLayout
          headerButtons={buttons}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar usuário"
        >
          <table className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, key) => {
                return (
                  <tr key={key}>
                    <td className="col-md-2">
                      {Util.getMaskedCPFCNPJ(row.cpf)}
                    </td>
                    <td className="col-md-3">{row.name}</td>
                    <td className="col-md-2">{row.email}</td>
                    <td className="col-md-2">
                      {Util.getMaskedPhone(row.telefone1)}
                    </td>
                    <td className="col-md-4">{row.roles[0].display_name}</td>
                    <td className="td-actions text-right">
                      <Link
                        title="Editar usuário"
                        className="btn btn-primary btn-simple btn-xs"
                        to={"usuarios/edit/" + row.id}
                      >
                        <i className="material-icons">edit</i>
                      </Link>
                      <button
                        type="button"
                        rel="tooltip"
                        title="Remover usuário"
                        onClick={() => this.delete(row.id)}
                        className="btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">close</i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableUsuarios)



// WEBPACK FOOTER //
// ./src/views/usuarios/TableUsuarios.js